import React, {useState, useEffect} from 'react';
import {Logo} from './components/Layout/Logo';
import {TransactionSection} from './components/Transactions/TransactionSection';
import {Footer} from './components/Layout/Footer'
import './App.css';


if (localStorage.getItem("$MEXPENSES")===null){
  localStorage.setItem("$MEXPENSES", 0);
}
if (localStorage.getItem("$TRANSACTIONS")===null){
  localStorage.setItem("$TRANSACTIONS", '[]');
}
if (localStorage.getItem("$BALANCE")===null){
  localStorage.setItem("$BALANCE", 0);
}
if (localStorage.getItem("$TEXPENSES")===null){
  localStorage.setItem("$TEXPENSES", 0);
}
if (localStorage.getItem("$SAVINGS")===null){
  localStorage.setItem("$SAVINGS", 0);
}
if (localStorage.getItem("$HEXPENSES")===null){
  localStorage.setItem("$HEXPENSES", 0);
}
if (localStorage.getItem("$HCREDIT")===null){
  localStorage.setItem("$HCREDIT", 0);
}
if (localStorage.getItem("$EJAN")===null){
  localStorage.setItem("$EJAN", 0);
  localStorage.setItem("$EFEB", 0);
  localStorage.setItem("$EMAR", 0);
  localStorage.setItem("$EAPR", 0);
  localStorage.setItem("$EMAY", 0);
  localStorage.setItem("$EJUN", 0);
  localStorage.setItem("$EJUL", 0);
  localStorage.setItem("$EAUG", 0);
  localStorage.setItem("$ESEP", 0);
  localStorage.setItem("$EOCT", 0);
  localStorage.setItem("$ENOV", 0);
  localStorage.setItem("$EDEC", 0);
}

function App(){
  return (<>
            <center>
              <Logo />
            </center>
            <TransactionSection/>
            <Footer/>
          </>
  );
}

export default App;
